export default "__VITE_ASSET__CkfBfo91__"